// extracted by mini-css-extract-plugin
export default {"paymentSection":"n7-z","disabled":"o7-z"};